export default {
  defaults: {
    debug: true,
    contentful_api: {
      space: '3051wtwpo93m',
      domain_entry_id: '60be4UbQgE8aqKa648Y8wi',
      // website_entry_id: '3WAPZaUGju6uImwyqEmsQO',
      access_token: 'a54bda8f2e19b16721102785971208cace75f58c68214994ba994228757ad100',
      content_types: 'https://cdn.contentful.com/spaces/3051wtwpo93m/environments/master/content_types',
      entries: 'https://cdn.contentful.com/spaces/3051wtwpo93m/environments/master/entries/',
      assets: 'https://cdn.contentful.com/spaces/3051wtwpo93m/environments/master/assets/',
      limit: 10
    },
    socket_api: {
      async: true,
      host: '',
      token: '',
      tokenName: 'token'
    },
    socket: {
      async: true,
      host: '',
      token: '',
      tokenName: 'token'
    }
    // mcAction: 'https://digigurus.us16.list-manage.com/subscribe/post?u=09283e07454e068bd65340edd&amp;id=3d6aaf4c34'
  }
}



// WEBPACK FOOTER //
// ./src/config/global.js